export const DEFAULT_DOCUMENT_TITLE = 'Gecko Cantilever'
